const company = () => {
  const targets = document.querySelectorAll('.c-title-normal.is-accordion') || [];
  console.log(targets);

  if (targets.length !== 0) {
    targets.forEach(target => {
      target.addEventListener('click', () => {
        target.classList.toggle('is-active');
        if (target.classList.contains('is-active')) {
          $(target).next().slideDown();
        } else {
          $(target).next().slideUp();
        }
      });
    });
  }
};

export default company;
